import type { MessageKey } from '@/modules/localizations';

/**
 * Opts a query into the shared failure report on `QueryProvider`'s cache: one toast and one logged
 * error per failed request, however many observers are mounted. Attach it as the query's `meta`.
 */
export const queryErrorMeta = (errorMessageId: MessageKey) => ({ errorMessageId });

/**
 * Opts a query into the shared failure log without a toast, for background reads whose failure the
 * UI absorbs silently.
 */
export const silentQueryErrorMeta = { logError: true };
